import React from 'react';
import { Fade } from 'react-reveal';
import Degree from './degree/Degree';
import Certifications from './certifications/Certifications';
import './EducationGreeting.css';
import GraduationImg from './GraduationImg';

const EducationGreeting = () => {
  return (
    <div className='education-main'>
      <div className='basic-education'>
        <Fade bottom duration={2000} distance='40px'>
          <div className='heading-div'>
            <div className='heading-img-div'>
              <GraduationImg />
            </div>
            <div className='heading-text-div'>
              <h1 className='heading-text'>Education</h1>
              <h3 className='heading-sub-text'>
                Degree, Qualifications and Certifications
              </h3>
            </div>
          </div>
          <Degree />
          <Certifications />
        </Fade>
      </div>
    </div>
  );
};

export default EducationGreeting;
